export default __webpack_public_path__ + "static/media/check.e1bb2dcc.svg";